import { render, staticRenderFns } from "./regionShow.vue?vue&type=template&id=234443e6&scoped=true"
import script from "./regionShow.vue?vue&type=script&lang=js"
export * from "./regionShow.vue?vue&type=script&lang=js"
import style0 from "./regionShow.vue?vue&type=style&index=0&id=234443e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234443e6",
  null
  
)

export default component.exports